/* eslint-disable */
import React from "react"
import { useState } from "react"
import Box from "@mui/material/Box"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { Grid, Typography, TableContainer, TablePagination, Button, Card, CardContent, IconButton, Chip, Select, MenuItem, Autocomplete, TextField } from "@mui/material"
import { Edit, CalendarToday, Language, Person } from "@mui/icons-material"
import { useEffect } from "react"
import moment from "moment"
import { INVOICE_APICALL } from "helper/api/api"
import DeleteItem from "helper/my-com/DeleteItem"
import { SOMETHING_ERR, TABLE_PAGINATION_DROPDOWN, TABLE_ROW_PER_PAGE } from "helper/Constant"
import NoData from "helper/my-com/NoData"
import PageLoader from "helper/my-com/PageLoader"
import { toastifyError, toastifySuccess } from "helper/Utility"
import FormControl from "@mui/material/FormControl"
import OutlinedInput from "@mui/material/OutlinedInput"
import BTNLoading from "helper/my-com/BTNLoading"
import { useNavigate } from "react-router"
const DomainOrHosting = () => {
    const [data, setData] = useState([])
    const [page, setPage] = useState(0)
    const [isForm, setIsForm] = useState(false)
    const [errors, setErrors] = useState({})
    const [rowsPerPage, setRowsPerPage] = useState(TABLE_ROW_PER_PAGE)
    const [loader, setLoader] = useState({
        pageLoading: false
    })
    const [options, setOptions] = useState([])
const [inputValue, setInputValue] = useState("")
const [searchLoading, setSearchLoading] = useState(false)

    const navigate = useNavigate()
    console.log("data", data)

    const [value, setValue] = useState({
        id: "",
        clientId: "",
        clientName: "",
        email: "",
        phone: "",
        address: "",
        domain: "",
        dateOfIssue: "",
        amount: "",
        type: []
    })

    const getDataListFun = async () => {
        setLoader({ ...loader, pageLoading: true })
        try {
            const res = await INVOICE_APICALL("admin/listHosting", "GET")
            if (res?.status) {
                setData(res?.data)
            } else {
                setData([])
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoader({ ...loader, pageLoading: false })
        }
    }

    useEffect(() => {
        getDataListFun()
    }, [])

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    const handleChange = (e) => {
        const key = e.target.name
        const value = e.target.value
        setValue((prev) => ({
            ...prev,
            [key]: value
        }))
    }

    const handleClose = () => {
        setValue({ id: "", clientId: "", clientName: "", email: "", phone: "", address: "", domain: "", dateOfIssue: "", amount: "", type: [] })
        setInputValue("")  
    setOptions([])
        setIsForm(!isForm)
        setErrors({})
    }

    const handleRenew = async (row) => {
        try {
            const res = await INVOICE_APICALL("admin/renewHosting", "POST", { id: row._id })
            if (res?.status) {
                toastifySuccess(res?.message)
                // Update locally
                setData(
                    (prev) => prev.map((item) => (item._id === row._id ? res.data : item)).sort((a, b) => new Date(a.expiryDate) - new Date(b.expiryDate)) // keep sort
                )
            } else {
                toastifyError(SOMETHING_ERR)
            }
        } catch (error) {
            toastifyError("Failed to renew plan")
        }
    }

    const handleGenerateInvoice = (row) => {
        navigate("/admin/invoice", {
            state: {
                prefillClient: {
                    clientId: row?.clientId || "",
                    name: row?.clientSnapshot?.name || "",
                    email: row?.clientSnapshot?.email || "",
                    phone: row?.clientSnapshot?.phone || "",
                    address: row?.clientSnapshot?.address || ""
                }
            }
        })
    }

    const handleSuspend = async (row) => {
        try {
            const res = await INVOICE_APICALL("admin/suspendHosting", "POST", {
                id: row._id,
                isSuspended: !row.isSuspended
            })
            if (res?.status) {
                toastifySuccess(res?.message)
                setData((prev) => prev.map((item) => (item._id === row._id ? { ...item, isSuspended: !row.isSuspended } : item)))
            } else {
                toastifyError(SOMETHING_ERR)
            }
        } catch (error) {
            toastifyError("Failed to update suspension status")
        }
    }

    const editClick = (row) => {
        setIsForm(true)
         setInputValue(row?.clientSnapshot?.name || row?.clientName || "")
        setValue({
            id: row?._id,
            clientId: row?.clientId || "",
            clientName: row?.clientSnapshot?.name || row?.clientName || "",
            email: row?.clientSnapshot?.email || "",
            phone: row?.clientSnapshot?.phone || "",
            address: row?.clientSnapshot?.address || "",
            domain: row?.domain,
            dateOfIssue: row?.dateOfIssue ? moment(row.dateOfIssue).format("YYYY-MM-DD") : "",
            amount: row?.amount || "",
            type: Array.isArray(row?.type)
                ? row.type
                : row?.type
                    ? [row.type]
                    : []
        })
    }

    const validate = () => {
        const newErrors = {}
        if (!value.clientName) newErrors.clientName = "Client Name is required"
        if (!value.domain) newErrors.domain = "Domain is required"
        if (!value.dateOfIssue) newErrors.dateOfIssue = "Date is required"
        if (!value.amount) newErrors.amount = "Amount is required"
        if (!value.type || value.type.length === 0)
            newErrors.type = "Type is required"
        return newErrors
    }


const fetchClients = async (searchTerm) => {
    if (!searchTerm?.trim()) {
        setOptions([])
        return
    }
    try {
        setSearchLoading(true)
        const res = await INVOICE_APICALL(`admin/searchClients?search=${searchTerm}`, "GET")
        if (res?.status) {
            setOptions(res?.data || [])
        } else {
            setOptions([])
        }
    } catch (err) {
        setOptions([])
    } finally {
        setSearchLoading(false)
    }
}




    const handleSubmit = async (e) => {
        e.preventDefault()
        const validationErrors = validate()
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors)
            return
        }
        try {
            setLoader((prev) => ({ ...prev, submitLoading: true }))
            const payload = {
                ...(value.id && { id: value.id }),
                ...(value.clientId && { clientId: value.clientId }),
                clientData: {
                    name: value.clientName,
                    email: value.email,
                    phone: value.phone,
                    address: value.address
                },
                domain: value.domain,
                dateOfIssue: value.dateOfIssue ? new Date(value.dateOfIssue).toISOString() : null,
                amount: Number(value.amount),
                type: value.type
            }
            const res = await INVOICE_APICALL("/admin/createOrUpdateHosting", "POST", payload)
            if (res?.status) {
                toastifySuccess(res?.message)
                getDataListFun()
                handleClose()
                setValue({
                    id: "",
                    clientName: "",
                    domain: "",
                    dateOfIssue: ""
                })
            } else {
                toastifyError(SOMETHING_ERR)
            }
        } catch (error) {
            console.log(error)
            toastifyError(error?.response?.data?.message || "Server Error")
        } finally {
            setLoader((prev) => ({ ...prev, submitLoading: false }))
        }
    }

    return (
        <>
            <div className="domain-hosting-container">
                <div className="invoice-header">
                    <div className="header-content">
                        <Typography variant="h4" className="page-title">
                            Domain Hosting Management
                        </Typography>
                        <Typography variant="body2" className="page-subtitle">
                            Manage your domain hosting records and renewal dates
                        </Typography>
                    </div>
                    <button className="toggle-form-btn" onClick={handleClose}>
                        {isForm ? "← Back to List" : "+ Add New"}
                    </button>
                </div>

                <Box className="main-content">
                    {!isForm ? (
                        <Card className="table-card" elevation={0}>
                            {loader?.pageLoading ? (
                                <PageLoader />
                            ) : (
                                <>
                                    {data.length > 0 ? (
                                        <>
                                            <TableContainer>
                                                <Table className="domain-table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>S.No</TableCell>
                                                            <TableCell>Client Name</TableCell>
                                                            <TableCell>Domain Name</TableCell>
                                                            <TableCell>Type</TableCell>
                                                            <TableCell>Amount</TableCell>
                                                            <TableCell>Client Email</TableCell>
                                                            <TableCell>Assign Date</TableCell>
                                                            <TableCell>Date of Issue</TableCell>
                                                            <TableCell>Expiry Date</TableCell>
                                                            <TableCell>Status</TableCell>
                                                            <TableCell align="right">Actions</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => (
                                                            <TableRow key={row._id} style={{ opacity: row.isSuspended ? 0.55 : 1, transition: "opacity 0.3s" }}>
                                                                <TableCell>{i + 1}</TableCell>
                                                                <TableCell className="client-name-cell">
                                                                    <div className="client-info">
                                                                        <Person className="cell-icon" />
                                                                        {row.clientSnapshot?.name}
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="domain-cell">
                                                                    <div className="domain-info">
                                                                        <Language className="cell-icon" />
                                                                        <span className="domain-text">{row.domain}</span>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell>
                                                                    {(() => {
                                                                        const types = Array.isArray(row.type) ? row.type : [row.type]

                                                                        const isDomain = types.includes("Domain Only")
                                                                        const isHosting = types.includes("Hosting Only")
                                                                        const isSSL = types.includes("SSL")

                                                                        // Simple priority color logic
                                                                        let bg = "#e8f4fd"
                                                                        let color = "#1565c0"

                                                                        if (isDomain && !isHosting && !isSSL) {
                                                                            bg = "#f3e8fd"
                                                                            color = "#6a1b9a"
                                                                        } else if (isHosting && !isDomain && !isSSL) {
                                                                            bg = "#e8fdf0"
                                                                            color = "#1b5e20"
                                                                        } else if (isSSL && !isDomain && !isHosting) {
                                                                            bg = "#fff3e0"
                                                                            color = "#e65100"
                                                                        } else {
                                                                            // multiple selected (like Domain + Hosting, etc.)
                                                                            bg = "#e3f2fd"
                                                                            color = "#0d47a1"
                                                                        }

                                                                        return (
                                                                            <Chip
                                                                                label={types.join(", ")}
                                                                                size="small"
                                                                                style={{
                                                                                    backgroundColor: bg,
                                                                                    color: color,
                                                                                    fontWeight: 600,
                                                                                    fontSize: 11
                                                                                }}
                                                                            />
                                                                        )
                                                                    })()}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <b>₹{Number(row.amount).toLocaleString("en-IN")}</b>
                                                                </TableCell>
                                                                <TableCell>{row?.clientSnapshot?.email || "—"}</TableCell>
                                                                <TableCell>
                                                                    <Chip icon={<CalendarToday />} label={moment(row.assignDate).format("DD MMM YYYY")} size="small" style={{ background: "#f1f5f9", color: "#475569" }} />
                                                                </TableCell>

                                                                {/* Date of Issue - updates on renew */}
                                                                <TableCell>
                                                                    <Chip icon={<CalendarToday />} label={moment(row.dateOfIssue).format("DD MMM YYYY")} size="small" className="date-chip" />
                                                                </TableCell>

                                                                {/* Expiry Date - color coded */}
                                                                <TableCell>
                                                                    {(() => {
                                                                        const daysLeft = moment(row.expiryDate).diff(moment(), "days")
                                                                        const isExpired = daysLeft < 0
                                                                        const isWarning = daysLeft <= 30 && daysLeft >= 0
                                                                        return (
                                                                            <Chip
                                                                                icon={<CalendarToday />}
                                                                                label={`${moment(row.expiryDate).format("DD MMM YYYY")} ${isExpired ? "(Expired)" : `(${daysLeft} day left)`}`}
                                                                                size="small"
                                                                                style={{
                                                                                    backgroundColor: isExpired ? "#fde8e8" : isWarning ? "#fff3e0" : "#e8fdf0",
                                                                                    color: isExpired ? "#b71c1c" : isWarning ? "#e65100" : "#1b5e20",
                                                                                    fontWeight: 600,
                                                                                    fontSize: 11
                                                                                }}
                                                                            />
                                                                        )
                                                                    })()}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Chip
                                                                        label={row.isSuspended ? "Suspended" : "Active"}
                                                                        size="small"
                                                                        style={{
                                                                            fontWeight: 600,
                                                                            fontSize: 11,
                                                                            backgroundColor: row.isSuspended ? "#fde8e8" : "#e8fdf0",
                                                                            color: row.isSuspended ? "#b71c1c" : "#1b5e20",
                                                                            border: `1px solid ${row.isSuspended ? "#f5c6c6" : "#a7f3d0"}`
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    <div className="action-buttons">
                                                                        <Button variant="outlined" size="small" onClick={() => handleGenerateInvoice(row)} style={{ color: "#2e7d32", borderColor: "#2e7d32", fontSize: 12, fontWeight: 600 }}>
                                                                            + Invoice
                                                                        </Button>
                                                                        <IconButton onClick={() => editClick(row)} className="action-btn edit-btn" size="small">
                                                                            <Edit fontSize="small" />
                                                                        </IconButton>
                                                                        <Button variant="outlined" size="small" onClick={() => handleRenew(row)} style={{ color: "#1565c0", borderColor: "#1565c0", fontSize: 12, fontWeight: 600 }}>
                                                                            🔄 Renew
                                                                        </Button>
                                                                        <DeleteItem url={"/admin/deleteHosting"} data={row} callFun={getDataListFun} />
                                                                    </div>
                                                                    <Button
                                                                        variant="outlined"
                                                                        size="small"
                                                                        onClick={() => handleSuspend(row)}
                                                                        style={{
                                                                            fontSize: 12,
                                                                            fontWeight: 600,
                                                                            color: row.isSuspended ? "#2e7d32" : "#b71c1c",
                                                                            borderColor: row.isSuspended ? "#2e7d32" : "#b71c1c"
                                                                        }}
                                                                    >
                                                                        {row.isSuspended ? "✓ Activate" : "⊘ Suspend"}
                                                                    </Button>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            <TablePagination rowsPerPageOptions={TABLE_PAGINATION_DROPDOWN} component="div" count={data?.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
                                        </>
                                    ) : (
                                        <NoData />
                                    )}
                                </>
                            )}
                        </Card>
                    ) : (
                        <Card className="form-card" elevation={0}>
                            <CardContent>
                                <form onSubmit={handleSubmit}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <div className="form-section-header">
                                                <Typography variant="h6" className="section-title">
                                                    Domain Information
                                                </Typography>
                                            </div>
                                        </Grid>

                                        {/* <Grid item xs={12} md={6}>
                                            <FormControl fullWidth className="form-field">
                                                <label className="field-label">
                                                    <Person className="label-icon" />
                                                    Client Name *
                                                </label>
                                                <OutlinedInput placeholder="Enter client name" value={value.clientName} onChange={handleChange} name="clientName" size="small" error={Boolean(errors.clientName)} />
                                                {errors.clientName && <span className="error-text">{errors.clientName}</span>}
                                            </FormControl>
                                        </Grid> */}

                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth className="form-field">
                                                <label className="field-label">
                                                    <Language className="label-icon" />
                                                    Domain Name *
                                                </label>
                                                <OutlinedInput placeholder="example.com" value={value.domain} onChange={handleChange} name="domain" size="small" error={Boolean(errors.domain)} />
                                                {errors.domain && <span className="error-text">{errors.domain}</span>}
                                            </FormControl>
                                        </Grid>

                                        {/* Client Details Section */}
                                        {/* <Grid item xs={12}>
                                            <div className="form-section-header">
                                                <Typography variant="h6" className="section-title">
                                                    Client Details
                                                </Typography>
                                            </div>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth className="form-field">
                                                <label className="field-label">
                                                    <Person className="label-icon" /> Client Name *
                                                </label>
                                                <OutlinedInput placeholder="Enter client name" value={value.clientName} onChange={handleChange} name="clientName" size="small" error={Boolean(errors.clientName)} />
                                                {errors.clientName && <span className="error-text">{errors.clientName}</span>}
                                            </FormControl>
                                        </Grid> */}


{/* Client Details Section */}
<Grid item xs={12}>
    <div className="form-section-header">
        <Typography variant="h6" className="section-title">
            Client Details
        </Typography>
    </div>
</Grid>

{/* ✅ Client Name — Autocomplete */}
<Grid item xs={12} md={6}>
    <FormControl fullWidth className="form-field">
        <label className="field-label">
            <Person className="label-icon" /> Client Name *
        </label>
        <Autocomplete
            freeSolo
            loading={searchLoading}
            options={options}
            getOptionLabel={(option) => (typeof option === "string" ? option : option.name)}
            inputValue={inputValue}
            onInputChange={(e, newInputValue) => {
                setInputValue(newInputValue)
                setValue((prev) => ({ ...prev, clientName: newInputValue }))
                fetchClients(newInputValue)
            }}
            onChange={(e, newValue) => {
                if (!newValue) {
                    setValue((prev) => ({ ...prev, clientId: "", clientName: "", email: "", phone: "", address: "" }))
                    return
                }
                if (typeof newValue === "object") {
                    // ✅ Existing client — saari details fill karo
                    setValue((prev) => ({
                        ...prev,
                        clientId: newValue._id,
                        clientName: newValue.name,
                        email: newValue.email,
                        phone: newValue.phone,
                        address: newValue.address,
                    }))
                }
                if (typeof newValue === "string") {
                    setValue((prev) => ({
                        ...prev,
                        clientId: "",
                        clientName: newValue,
                        email: "",
                        phone: "",
                        address: ""
                    }))
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Search client name..."
                    error={Boolean(errors.clientName)}
                    helperText={errors.clientName}
                    size="small"
                />
            )}
        />
    </FormControl>
</Grid>


                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth className="form-field">
                                                <label className="field-label">Email</label>
                                                <OutlinedInput placeholder="client@example.com" value={value.email} onChange={handleChange} name="email" size="small" />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth className="form-field">
                                                <label className="field-label">Phone</label>
                                                <OutlinedInput
                                                    placeholder="10-digit number"
                                                    value={value.phone}
                                                    onChange={(e) => {
                                                        const onlyNums = e.target.value.replace(/[^0-9]/g, "")
                                                        if (onlyNums.length <= 10) setValue((prev) => ({ ...prev, phone: onlyNums }))
                                                    }}
                                                    name="phone"
                                                    size="small"
                                                    inputProps={{ maxLength: 10 }}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth className="form-field">
                                                <label className="field-label">Address</label>
                                                <OutlinedInput placeholder="Enter address" value={value.address} onChange={handleChange} name="address" size="small" multiline rows={2} />
                                            </FormControl>
                                        </Grid>

                                        {/* Service Details Section */}
                                        <Grid item xs={12}>
                                            <div className="form-section-header">
                                                <Typography variant="h6" className="section-title">
                                                    Service Details
                                                </Typography>
                                            </div>
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <FormControl fullWidth className="form-field">
                                                <label className="field-label">Amount (₹) *</label>
                                                <OutlinedInput
                                                    placeholder="Enter amount"
                                                    value={value.amount}
                                                    onChange={(e) => {
                                                        const onlyNums = e.target.value.replace(/[^0-9.]/g, "")
                                                        setValue((prev) => ({ ...prev, amount: onlyNums }))
                                                    }}
                                                    name="amount"
                                                    size="small"
                                                    startAdornment="₹"
                                                    error={Boolean(errors.amount)}
                                                />
                                                {errors.amount && <span className="error-text">{errors.amount}</span>}
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <FormControl fullWidth size="small" className="form-field" error={Boolean(errors.type)}>
                                                <label className="field-label">Type *</label>
                                                <Select
                                                    multiple
                                                    value={Array.isArray(value.type) ? value.type : []}
                                                    onChange={(e) => {
                                                        setValue((prev) => ({
                                                            ...prev,
                                                            type: e.target.value
                                                        }))
                                                    }}
                                                    name="type"
                                                    displayEmpty
                                                    renderValue={(selected) =>
                                                        selected.length ? selected.join(", ") : "Select Type"
                                                    }
                                                >
                                                    <MenuItem value="">
                                                        <em>Select Type</em>
                                                    </MenuItem>
                                                    <MenuItem value="Domain Only">Domain Only</MenuItem>
                                                    <MenuItem value="Hosting Only">Hosting Only</MenuItem>
                                                    <MenuItem value="SSL">SSL</MenuItem>
                                                    <MenuItem value="Apple">Apple</MenuItem>
                                                </Select>
                                                {errors.type && <span className="error-text">{errors.type}</span>}
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth className="form-field">
                                                <label className="field-label">
                                                    <CalendarToday className="label-icon" />
                                                    Date of Issue *
                                                </label>
                                                <OutlinedInput
                                                    type="date"
                                                    value={value.dateOfIssue || ""}
                                                    onChange={(e) => {
                                                        setValue((prev) => ({
                                                            ...prev,
                                                            dateOfIssue: e.target.value
                                                        }))
                                                    }}
                                                    name="dateOfIssue"
                                                    size="small"
                                                    error={Boolean(errors.dateOfIssue)}
                                                />
                                                {errors.dateOfIssue && <span className="error-text">{errors.dateOfIssue}</span>}
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <div className="form-actions">
                                                <Button variant="outlined" onClick={handleClose} className="cancel-btn">
                                                    Cancel
                                                </Button>
                                                {loader?.submitLoading ? (
                                                    <BTNLoading className="submit-btn" />
                                                ) : (
                                                    <Button type="submit" variant="contained" className="submit-btn">
                                                        Save Domain
                                                    </Button>
                                                )}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </form>
                            </CardContent>
                        </Card>
                    )}
                </Box>
            </div>
        </>
    )
}

export default DomainOrHosting
